<template>
  <div class="container">
    <img src="../../img/ecoute/satellite.svg" class="satellite" alt="">

    <div class="content flex-column">
      <div class="flex-row-space-evenly">
        <div class="ligne-vert"></div>
        <p>Philosophie et valeurs</p>
      </div>
      <h1>Écoute, éthique, réactivité, confiance, rigueur</h1>
      <p>CYBERDINE CONSEIL c’est avant tout une équipe de personnes
        qui cherchent à s’épanouir dans leur travail.</p>
      <button @click="changeTo('societe-philosophie')">En savoir plus</button>
    </div>

    <div class="image-container">
      <img src="../../img/ecoute/element_graphique.svg" class="photo" alt="">
      <div class="container-photo"><img src="../../img/ecoute/image_philosophie.png" class="photo image" alt=""></div>
    </div>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    export default {

        methods: {
            changeTo(pageName) {
                menuBus.$emit('changePage', pageName);
            }
        },
        mounted() {
            menuBus.$on('changePage', (pageName, idName) => {
                this.menuShowed = false;
            });
        }
    }
</script>

<style scoped>
  .container {
    height: 500px;
    width: 100%;

    position: relative;
  }

  img {
    position: absolute;
    height: 80%;
  }

  .satellite {
    left: 0;
    top: 0;
    height: 50%;
  }

  .photo {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .photo.image {
    height: 300px;
    right: 50px;

    top: 15%;

    -webkit-animation: orbit-effect 5s linear infinite;
    -moz-animation: orbit-effect 5s linear infinite;
    -o-animation: orbit-effect 5s linear infinite;
    animation: orbit-effect 5s linear infinite;
  }

  .ligne-vert {
    background-color: #b7e17e;
    width: 50px;
    height: 4px;
    margin-right: 10px;
  }

  .content {
    width: 30%;
    height: 100%;
    min-width: 350px;
    margin-left: 17%;

    align-items: flex-start;
  }

  .content div p {
    color: #b7e17e;
    text-transform: uppercase;
    font-weight: bolder;
  }
  .content h1 {
    margin: 0;
    color: #162139;
    font-weight: 700;
    width: 70%;
    text-align: left;
    line-height: 1.2;
  }
  .content p {
    text-align: left;
    color: #9fa8bd;
    font-size: 20px;
  }
  .content button {
    border: 1px solid rgba(183, 225, 126, 0);
    background-color: #b7e17e;
    color: white;
    padding: 20px 30px;
    text-transform: uppercase;
    margin-top: 10px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 15px;
    font-weight: bold;
  }
  .content button:hover {
    border: 1px solid #b7e17e;
    background: none;
    color: #b7e17e;
  }

  @-webkit-keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(5px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(5px) rotate(-360deg); }
  }
  @-moz-keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(5px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(5px) rotate(-360deg); }
  }
  @-o-keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(5px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(5px) rotate(-360deg); }
  }
  @keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(5px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(5px) rotate(-360deg); }
  }


  /* Mobile */
  @media (max-width: 1200px) {
    .satellite {
      display: none;
    }
    .container {
      height: fit-content;
      height: -moz-fit-content;
      margin: 0;
    }

    .image-container {
      max-height: 300px;
      height: 300px;
      width: 100%;

      position: relative;
    }

    .photo {
      position: static;
      right: auto;
      top: auto;
      transform: none;
    }
    img {
      position: static;
    }
    .photo {
      height: 100%;
      max-width: 100%;
    }
    .photo.image {
      max-height: 100%;
      max-width: 100%;
      height: auto;
      width: auto;
    }
    .container-photo {
      height: 80%;
      max-width: 100%;
      width: 70%;

      position: absolute;
      left: 50%;
      transform: translateX(-43%);
      bottom: 30px;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    .container {
      padding: 20px 0;
    }

    .content {
      max-width: 65%;
      min-width: auto;
      width: 100%;
    }
  }

  /* Mobile extra small */
  @media (max-width: 500px) {
    h1 {
      width: 100% !important;
    }
    .ligne-vert {
      height: 3px;
      width: 40px;
    }
    .content div p {
      font-size: 16px;
    }
    .content > p {
      font-size: 17px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/Ecoute.vue